import { render, staticRenderFns } from "./gameSceneConfig.vue?vue&type=template&id=0560feb8&"
import script from "./gameSceneConfig.vue?vue&type=script&lang=js&"
export * from "./gameSceneConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0560feb8')) {
      api.createRecord('0560feb8', component.options)
    } else {
      api.reload('0560feb8', component.options)
    }
    module.hot.accept("./gameSceneConfig.vue?vue&type=template&id=0560feb8&", function () {
      api.rerender('0560feb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameSceneConfig.vue"
export default component.exports